import { useMemorandumLogo } from "hooks/MemorandumLogo";
import { selectState } from "../outputSlice";
import { useSelector } from "react-redux";
import { FormatDateShort, GetTodayDate } from "utils/dateUtils";
import {
  FormatNumber,
  FormatNumberWithUnitOrNull
} from "utils/numberUtils";

const PrintStateOfOutput = () => {
  const memorandumLogo = useMemorandumLogo();
  const { totalQuantityAmount, totalCost, outputs }
    = useSelector(selectState);

  return (
    <div className="lager-page">
      <div className="stock-output-header-container">
        <div className="logo">
          {memorandumLogo && <img src={memorandumLogo} alt="" />}
        </div>
        <div>
          <h1 className="stock-output-header">Betonska baza - IZLAZ</h1>
        </div>
        <div className="date">{GetTodayDate()}</div>

      </div>
      <table className="table-header stock-output-header stock-output-size">
        <tbody>
          <tr>
            <th>br.otp.rač</th>
            <th className="name">ime</th>
            <th>projekat</th>
            <th>kol izdato</th>
            <th>cena</th>
            <th>datum</th>
          </tr>
        </tbody>
      </table>
      <table className="table-body stock-output-size stock-output">
        <tbody>
          {outputs.map((outputListItem, itemIndex) =>
            <tr key={outputListItem.outputItemId}>
              <td>
                <label className="check"></label>
                <label>{outputListItem.billOfLandingId}</label>
              </td>
              <td>
                <div className="name-container">
                  <div>
                    <label className="name">{outputListItem.name}</label>
                    <label className="supplier">{outputListItem.supplier}</label>
                  </div>
                  <label className="badge">
                    {outputListItem.repository.shortName}
                  </label>
                </div>
              </td>
              <td className="destination-cell">
                <div>
                  <label className="destination">
                    {outputListItem.whereWentToOnBill}
                  </label>
                  <label className="taken-away-by">
                    {outputListItem.quantity > 0
                      ? outputListItem.takenAwayByDriverAndVehicle : ""}
                  </label>
                </div>
              </td>
              <td>
                <div>
                  <label>
                    <b>{FormatNumber(outputListItem.quantity)}</b>
                    {outputListItem.unit.name}
                  </label>
                </div>
              </td>
              <td>
                <label>{FormatNumberWithUnitOrNull(outputListItem.totalCost, 'rsd')}</label>
              </td>
              <td>{FormatDateShort(outputListItem.dateOfOutput)}</td>
            </tr>
          )}
        </tbody>
        <tfoot>
          <tr className="footer">
            <td></td>
            <td></td>
            <td>ukupno</td>
            <td>
              <label>{FormatNumber(totalQuantityAmount)}</label>
            </td>
            <td colSpan={2}>
              <label>{FormatNumberWithUnitOrNull(totalCost, 'rsd')}</label>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default PrintStateOfOutput;
